'use strict';

module.exports = {
    subCampaignModel: 'subCampaignModel',
    startDatesModel: 'startDatesModel',
    childrenModel: 'childrenModel',
};
